import { AxiosResponse } from 'axios';
import React, { ChangeEvent, createRef, useState } from 'react';
import { Card, CardContent, Button, Box } from '@mui/material';
import { reactFormatter } from 'react-tabulator';
import TableView from '../../Components/tableView';
import constants from '../../constants';
import ChangeMailRequest from '../../Model/changeMailRequest';
import ChangeLicenseExpirationDateRequest from '../../Model/changeLicenseExpirationDateRequest';
import './licenses.scss';
import moment from 'moment';
//import 'antd/dist/antd.css';
import 'antd/lib/date-picker/style';
import LicenseTransactionsModal from '../../Components/Licenses/LicenseTransactionsModal';
import ChangeMailModal from '../../Components/Licenses/ChangeMailModal';
import Actions from '../../Components/Licenses/Actions';
import { formatterSensor } from '../../utils/formatterSensor';
import { formatterDate } from '../../utils/formatterDate';
import AlgoTransactionModal from '../../Components/Licenses/AlgoTransactionModal';
import ExpirationDateModal from '../../Components/Licenses/ExpirationDateModal';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import Loader from '../../common-components/loader';
import {
  changeLicenseExpirationDateService,
  changeMailService,
  freeLicenseService,
  getAlgoInfo,
  getLicensesReport,
  getLicenseTransactions
} from '../../api/licenses';
import { useTranslation } from 'react-i18next';
import CustomAlert, { CustomAlertType } from '../../Components/CustomAlert';

// Aggiungere NFTAssetID in tabella e in alert
const Licenses = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [showModal, setShowModal] = useState<boolean>(false);
  const [newMail, setNewMail] = useState<string>('');
  const [licenseId, setLicenseId] = useState<number>(0);
  const [showModalLicense, setShowModalLicense] = useState<boolean>(false);
  const [showModalLicenseExpirationDate, setShowModalLicenseExpirationDate] =
    useState<boolean>(false);
  const [licenseTransactions, setLicenseTransactions] = useState<any[]>([]);
  const [showModalAlgo, setShowModalAlgo] = useState<boolean>(false);
  const [algorandTransaction, setAlgorandTransaction] = useState<any>();
  const [newLicenseExpirationDate, setNewLicenseExpirationDate] = useState<string>(moment().format('YYYY-MM-DD'));
  const [newLicenseActivationDate, setNewLicenseActivationDate] = useState<string>(moment().format('YYYY-MM-DD'));

  const [currentActivationDateValue, setCurrentActivationDateValue] =
    useState<string>('');
  const [currentExpirationDateValue, setCurrentExpirationDateValue] =
    useState<string>('');
  const [onChangeActivated, setOnChangeActivated] = useState<boolean>(false);
  const [totalSensors, setTotalSensors] = useState<number>(0);
  const [errorType, setErrorType] = useState<CustomAlertType>();

  const { t } = useTranslation();

  const licensesTable = createRef<TableView>();

  const openModalLicense = (id: number) => {
    setShowModalLicense(!showModalLicense);
    setLicenseId(id);
    // axios.get(constants.api.getLicenses).then((res) => {
    //   setLicenses(res.data);
    // });
  };

  const openAlgoInfo = async (txId: string) => {
    if (txId !== null) {
      setShowModalAlgo(true);

      try {
        const result: AxiosResponse = await getAlgoInfo(txId);
        if (result) {
          setAlgorandTransaction(result.data);
        }
      } catch (error: any) {
        if (error.response?.status === 404) {
          setShowModalAlgo(false);
          setErrorMessage(t('NO_TX_FOUND_ON_INDEXER'));
          setShowError(true);
          return;
        }
        setShowModalAlgo(false);
        setErrorMessage(t('TX_INDEXER_GENERIC_ERROR'));
        setShowError(true);
      }
    } else {
      setErrorMessage(t('TX_ERROR'));
      setShowError(true);
    }
  };

  // sensorFriendlyName = (type: string, device_number: number) => `PW:${type}_${device_number.toString().padStart(6, '0')}`;
  const licenseTransactionApi = async (id: any) => {
    try {
      const result: AxiosResponse = await getLicenseTransactions(id);
      if (result) {
        setLicenseTransactions(result?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const freeLicense = async (id: number) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const check = window.confirm(t('CONFIRM_LICENSE_FREE'));
    // setIsFreeLicense(true);
    // setIsConfirmedFreeLicense(check);
    if (check) {
      setLoading(false);
      try {
        const result: AxiosResponse = await freeLicenseService(id);
        if (result.data.success) {
          licensesTable.current?.reloadData();
          setErrorType(CustomAlertType.INFO);
          setShowError(true);
          setErrorMessage(t('SAVED_DATA'));
        }
      } catch (error: any) {
        setErrorType(CustomAlertType.ERROR);

        setShowError(true);
        setErrorMessage(error.response.data.errorMessage);
      } finally {
        setLoading(false);
      }
    }
    return null;
  };

  const changeMail = async (id: number) => {
    setShowModal(true);
    setLicenseId(id);
  };

  const changeLicenseExpirationDate = async (
    id: number,
    currentExpirationDate: string,
    currentActivationDate: string
  ) => {
    setShowModalLicenseExpirationDate(true);
    setLicenseId(id);
    if (currentExpirationDate) {
      setCurrentExpirationDateValue(currentExpirationDate);
    } else {
      setCurrentExpirationDateValue('');
    }

    if (currentActivationDate)
      setCurrentActivationDateValue(currentActivationDate);
    else setCurrentActivationDateValue('');
  };

  const columns = [
    {
      title: t('ID'),
      field: 'id',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('NFT'),
      field: 'nft',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('NFT_NAME'),
      sortable: false,
      headerSort: false,
      headerFilter: false,
      formatter: (cell: any) => formatterSensor(cell)
    },
    {
      title: t('SENSOR_ID'),
      field: 'sensorId',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('TYPE'),
      field: 'type',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('MAIL'),
      field: 'mail',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('ORDER_ID'),
      field: 'orderId',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('ACTIVATION_DATE'),
      field: 'activationDate',
      sorter: 'string',
      headerFilter: 'input',
      formatter: (cell: any) => formatterDate(cell)
    },
    {
      title: t('EXPIRATION_DATE'),
      field: 'expirationDate',
      sorter: 'string',
      headerFilter: 'input',
      formatter: (cell: any) => formatterDate(cell)
    },
    {
      title: t('RENEWED'),
      field: 'renewalActivationDate',
      //TODO: Enable sorter/filter -> backend must support it...
      sorter: null,
      headerFilter: null,
      formatter: 'tickCross',
      mutator: (value: string) => {
        return value !== undefined && value !== null;
      }
    },
    {
      title: t('TRANSFERABLE'),
      field: 'transferable',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: '',
      sortable: false,
      width: '250',
      formatter: reactFormatter(
        <Actions
          props={{
            t: t,
            freeLicense: freeLicense,
            changeMail: changeMail,
            changeLicenseExpirationDate: changeLicenseExpirationDate,
            changeLicenseActivationDate: changeLicenseExpirationDate,
            openModalLicense: openModalLicense,
            openAlgoInfo: openAlgoInfo,
            licenseTransactions: licenseTransactionApi
          }}
        />
      ),
      headerSort: false
    }
  ];

  const closeModal = () => {
    setShowModal(false);
    setShowModalLicense(false);
    setShowModalAlgo(false);
    setShowModalLicenseExpirationDate(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  const handleSubmit = async () => {
    setShowModal(false);
    setLoading(true);
    const submitData: ChangeMailRequest = {
      mail: newMail
    };
    try {
      const result: AxiosResponse = await changeMailService(
        licenseId,
        submitData
      );
      if (result.data.success === true) {
        licensesTable.current?.reloadData();
        setErrorType(CustomAlertType.INFO);
        setShowError(true);
        setErrorMessage(t('SAVED_DATA'));
      }
    } catch (error: any) {
      setErrorType(CustomAlertType.ERROR);
      setShowError(true);
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitLicenseExpirationDate = async () => {
    setShowModalLicenseExpirationDate(false);
    setLoading(true);

    const submitData: ChangeLicenseExpirationDateRequest = {
      expirationDate: newLicenseExpirationDate ? newLicenseExpirationDate : null,
      activationDate: newLicenseActivationDate ? newLicenseActivationDate : null
    };

    try {
      const result: AxiosResponse = await changeLicenseExpirationDateService(
        licenseId,
        submitData
      );
      if (result.data.success) {
        setShowModalLicense(false);
        licensesTable.current?.reloadData();
      }
    } catch (error) {
      setShowModalLicenseExpirationDate(false);
      setErrorMessage(t('NOT_SAVED_DATA'));
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };




  const onChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setNewMail(value);
  };


  const onChangeActivationDate = (date: Date | null) => {
    setOnChangeActivated(true);
    setNewLicenseActivationDate(date ? moment(date).format('YYYY-MM-DD') : '');
  };

  const onChangeExpirationDate = (date: Date | null) => {
    setOnChangeActivated(true);
    setNewLicenseExpirationDate(date ? moment(date).format('YYYY-MM-DD') : '');
  };

  const downloadReport = async () => {
    setLoading(true);

    try {
      const result: AxiosResponse = await getLicensesReport();
      if (result.data?.success) {
        const a = document.createElement('a');
        a.href = `data:${result.data.data.mime};base64,${result.data.data.base64}`;
        a.download = result.data.data.filename;
        a.click();
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      setShowError(true);
      setErrorMessage(error?.response?.data?.errorMessage);
    }
  };

  return (
    <>
      <Card>
        <CardContent style={{ width: '100%' }}>
          <b>{t('TOTAL').toUpperCase()}</b>: {totalSensors}
          <div>
            <Box sx={{ height: 10 }}></Box>
            <Button
              onClick={() => downloadReport()}
              variant="outlined"
              startIcon={<FilePresentIcon />}
            >
              {t('DOWNLOAD_REPORT')}
            </Button>
          </div>
        </CardContent>
      </Card>

      <TableView
        t={t}
        id={'licences'}
        ref={licensesTable}
        api={constants.api.getLicenses}
        columns={columns}
        onApiCalled={(response) => setTotalSensors(response.pagination.total)}
      />
      <LicenseTransactionsModal
        closeModal={closeModal}
        licenseTransactions={licenseTransactions}
        showModalLicense={showModalLicense}
      />

      <ChangeMailModal
        showModal={showModal}
        closeModal={closeModal}
        handleSubmit={() => handleSubmit()}
        onChangeValue={(e: any) => onChangeValue(e)}
      />

      <ExpirationDateModal
        showModalLicenseExpirationDate={showModalLicenseExpirationDate}
        closeModal={closeModal}
        onChangeActivated={onChangeActivated}
        newLicenseExpirationDate={newLicenseExpirationDate}
        newLicenseActivationDate={newLicenseActivationDate}
        currentActivationDate={currentActivationDateValue}
        currentExpirationDate={currentExpirationDateValue}
        onChangeActivationDate={(value: any) => onChangeActivationDate(value)}
        onChangeExpirationDate={(value: any) => onChangeExpirationDate(value)}
        handleSubmitLicenseExpirationDate={handleSubmitLicenseExpirationDate}
      ></ExpirationDateModal>

      <AlgoTransactionModal
        algorandTransaction={algorandTransaction}
        closeModal={() => closeModal()}
        showModalAlgo={showModalAlgo}
      />
      <Loader fullscreen={true} visible={loading} />

      <CustomAlert
        type={errorType}
        show={showError}
        message={errorMessage}
        onClose={() => {
          setShowError(false);
          setErrorMessage('');
        }}
      />
    </>
  );
};

export default Licenses;
